export default __webpack_public_path__ + "static/media/birthday.71abfd24.svg";